import { IComponentsConfig } from '../../_Common/Components/BusinessCollectionComponents/businessCollectionComponents';
import { initConst } from '../../../../Utils/utils';
import { gravplats } from './Gravplats/GravplatsVy';

export const GAVyer = initConst<IComponentsConfig>(() => ({
  GAGrav: [gravplats],
}));
